/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    ///**
    // * Pricing switch period
    // */
    //$('body').on('change', '[name=switch-period]', function() {
    //    if ($(this).val() == 'year') {
    //        $('.pricing-block.month').hide();
    //        $('.pricing-block.year').show();
    //    }
    //    else {
    //        $('.pricing-block.month').show();
    //        $('.pricing-block.year').hide();
    //    }
    //});
    //$('[name=switch-period]').trigger('change');
    
    /**
     * Go Pro popup switch period
     */
    $('#go-pro-popup').on('change', '[name=period]', function() {
        var popup = $('#go-pro-popup');
        var period = $(this).val();
        
        popup.find('.price-display').each(function(k, v) {
            var e = $(v);
            e.text('$' + e.data('price-' + period) + '/' + period);
        });
    });
    $('#go-pro-popup [name=period]').trigger('change');

    /**
     * Go Pro popup switch plans
     */
    $('body').on('click', '[data-popup="#go-pro-popup"]', function() {
        if ($(this).data('plan')) {
            $('#go-pro-popup').find('[name=plan][value=' + $(this).data('plan') + ']').trigger('change').trigger('click');
        }
        
        if ($(this).data('period')) {
            $('#go-pro-popup').find('[name=period]').val($(this).data('period')).trigger('change');
        }
    });

    ///**
    // * Go Pro popup active fields
    // */
    //$('#go-pro-popup').on('change', '[name=provider]', function() {
    //    var popup = $('#go-pro-popup');
    //    if ($(this).val() == 'paypal') {
    //        popup.find('.details-paypal').show();
    //        popup.find('.details-card').hide();
    //    }
    //    else {
    //        popup.find('.details-paypal').hide();
    //        popup.find('.details-card').show();
    //    }
    //});
    //$('#go-pro-popup [name=provider][value=card]').trigger('change');
});
